import { publicUrls } from "@constants/constants";
export enum LoginSourceType {
  GOOGLE = "google",
  FACEBOOK = "facebook",
  LINKEDIN = "linkedin",
  TWITTER = "twitter",
  YAHOO = "yahoo",
  EMAIL = "EMAIL",
  MOBILE = "MOBILE",
  EMAIL_AND_MOBILE = "EMAIL_AND_MOBILE",
}

export enum OtpLocationType {
  REGISTRATION = "registration",
  FORGOTPASSWORD = "forgotPassword",
}

export enum FieldType {
  EMAILORMOBILE = "emailOrMobile",
  PASSWORD = "password",
  CONFIRMPASSWORD = "confirmPassword",
}
export const tokenRefreshTimeBeforeExpiry = 60 * 60 * 24 * 1000; //86400000 1 day in milisecond; 60*60*24*1000

export const getTokenExpiryAndRefreshTime = (
  tokenExpiresIn: string
): { tokenExpiryTime: number; tokenRefreshTime: number } => {
  const currentDateTimeInMilliSecond: number = new Date().getTime();
  const tokenExpiryTime: number =
    Number(tokenExpiresIn) * 1000 + Number(currentDateTimeInMilliSecond);
  const tokenRefreshTime: number =
    tokenExpiryTime - tokenRefreshTimeBeforeExpiry;

  return { tokenExpiryTime, tokenRefreshTime };
};

export const getRedirectUri = () => {
  const currentPath = window.location.pathname;
  for (const url of publicUrls) {
    if (currentPath.includes(url)) {
      return window.location.origin + currentPath;
    }
  }
  return window.location.origin;
};
